export const STRIPE = 'stripe';
export const ERRORS = 'errors';
export const STRIPE_ERROR = 'stripeError';
export const CONTRACT_ID_ERROR = 'contractId';
